<script>
export default {
  name: 'CandidateStatItem',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    skeletonWidth: {
      type: String,
      default: '40px',
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column">
    <span v-if="isLoading">
      <v-skeleton-loader
        loading
        :style="`width: ${skeletonWidth}; height: 20px;`"
        type="image"
      />
    </span>
    <span v-else class="text-body-2">
      <v-icon v-if="icon" size="20">{{ icon }}</v-icon>
      <slot />
    </span>
  </div>
</template>
